import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { Users } from "@/domain/users.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";
import { Password } from "@/domain/password.model";

export default class UsersService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: Users): Promise<Users> => {
    return httpClient
      .request<Users>({
        url: `${this.urlApiBase}/user`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: Users): Promise<Users> => {
    return httpClient
      .request<Users>({
        url: `${this.urlApiBase}/user/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static changePassword = (data: Password): Promise<Users> => {
    return httpClient
      .request<Users>({
        url: `${this.urlApiBase}/user/${data.id}/change-password`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<Users> => {
    const url = `${this.urlApiBase}/user/${id}`;

    return httpClient
      .request<Users>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: Record<string, unknown>,
  ): Promise<IPaginateVueTable<Users>> => {
    const query = formatQueryString(offset, limit, order, sort, filter, true);
    const url = `${this.urlApiBase}/user${query}`;

    return httpClient
      .request<IPaginateVueTable<Users>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<Users[]> => {
    const url = `${this.urlApiBase}/user/list-active`;

    return httpClient
      .request<Users[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<Users> => {
    const url = `${this.urlApiBase}/user/${id}`;

    return httpClient
      .request<Users>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
